import { Component } from '@angular/core';
import { ContactUsService } from '../core/services/contact-us.service';

@Component({
  selector: 'app-req-loss-run',
  standalone: true,
  imports: [],
  templateUrl: './req-loss-run.component.html',
  styleUrl: './req-loss-run.component.css'
})
export class ReqLossRunComponent {
  constructor(private contactUsService: ContactUsService) {}

  get contentLabels() { return this.contactUsService.contentLabels; }
}
